import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"

import AccommodationMixin from '../mixins/accommodation_mixin'
import Loading from './loading'
import createReactClass from 'create-react-class'
export default createReactClass({
  mixins: [AccommodationMixin],

  render() {
    switch (this.props.screenSize) {
      default:
        return <Loading />
      case 'mobile':
        return this.renderMobile()
      case 'desktop':
        return this.renderDesktop()
    }
  },

  parseEntity(text) {
    return text.replace(/&#([0-9]{1,3});/gi, function(match, index) {
      const num = parseInt(index, 10);
      return String.fromCharCode(num);
    });
  },

  renderDesktop() {
    let favorite_class = 'favorite-icon icon-heart-1';
    if (this.props.accommodation.favorited) { favorite_class += ' favorite-active'; }

    const sold_banner = this.props.accommodation.sold_on_date ?
      // box__ribbon box__ribbon--sold
      <div className='sold_banner'>{I18n.t('sale_adverts.sold')}</div>
    :
      '';

    return <div className="box box--horizontal">
      <a href={this.props.accommodation.path}  className='box__inner' title={[this.props.accommodation.object_name, this.props.accommodation.city.name, this.props.accommodation.departement.name].join(" - ")}>
        <div className="box__cell">
          <div className="box__visual" style={{ backgroundImage: `url(${this.props.accommodation.image})` }}>
            <img src={this.props.accommodation.image} />
            <div className="box__overlay box__overlay--hover">
              <div className="box__overlay-wrapper">
                <div className="box__overlay-inner">
                  {sold_banner}
                  <h3 className="box__title">{this.object_name(this.props.accommodation.object_name)}</h3>
                  {
                    this.props.favoriting ?
                      <div className="favorite-wrapper">
                        <div onClick={this.favorite} className={favorite_class} ></div>
                      </div> : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='box__cell box__body'>
          <div className="price price--accomodation">
            <div className='price__amount'>{this.props.accommodation.price}</div>
            <div className='price__label'>{this.props.accommodation.maintenance}</div>
          </div>

          <ul className="iconbar iconbar--accommodation">
            <li className="iconbar__item icon-premises" title={I18n.t('search.info.plot_space', {count: this.parseEntity(this.props.accommodation.plot_space)})}>
              <div className="iconbar__count">{this.parseEntity(this.props.accommodation.plot_space)}</div>
            </li>
            <li className="iconbar__item icon-house" title={I18n.t('search.info.living_space', {count: this.parseEntity(this.props.accommodation.living_space)})}>
              <div className="iconbar__count">{this.parseEntity(this.props.accommodation.living_space)}</div>
            </li>
            <li className="iconbar__item icon-room" title={I18n.t('search.info.rooms', {count: this.props.accommodation.rooms})}>
              <div className="iconbar__count">{this.props.accommodation.rooms}</div>
            </li>
          </ul>
        </div>
      </a>
    </div>;
  },

  renderMobile() {
    let favorite_class = 'favorite-icon icon-heart-1';
    if (this.props.accommodation.favorited) { favorite_class += ' favorite-active'; }

    const sold_banner = this.props.accommodation.sold_on_date ?
      // box__ribbon box__ribbon--sold
      <div className='box__circle box__circle--sold'>{I18n.t('sale_adverts.sold')}</div>
    :
      '';

    return <div className="box box--mobile">
      <a href={this.props.accommodation.path} className="box__inner" title={[this.props.accommodation.object_name, this.props.accommodation.city.name, this.props.accommodation.departement.name].join(" - ")}>
     <div className="box__cell">
       <div className="box__visual" style={{ backgroundImage: `url(${this.props.accommodation.image})` }}>
         <img src={this.props.accommodation.image} />
           <div className="box__overlay-wrapper">
             <div className="box__overlay-inner">
               {
                 this.props.favoriting ?
                   <div className="favorite-wrapper">
                     <div onClick={this.favorite} className={favorite_class} ></div>
                   </div> : null
               }
             </div>
           </div>
         </div>
       </div>
      <div className="box__cell box--purple">
          <div className="box__title box__title--full">
            {sold_banner}
            <h3>{this.object_name(this.props.accommodation.object_name)}</h3>
            <div className="box__subtitle">{this.props.accommodation.city.name}</div>
          </div>
          <div className="price price--accomodation price--left">
            <div className='price__amount'>{this.props.accommodation.price}</div>
            <div className='price__label'>{this.props.accommodation.maintenance}</div>
          </div>
        </div>
      </a>
    </div>;
  }
});
